/**
 * BalanceIcon — sanitized from `assets/newSvg/balance.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function BalanceIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M5,4 C5,2.89543 5.89543,2 7,2 L17,2 C18.1046,2 19,2.89543 19,4 L19,5.85926 C19,7.53103 18.1645,9.09219 16.7735,10.0195 L13.8028,12 L16.7735,13.9805 C18.1645,14.9078 19,16.469 19,18.1407 L19,20 C19,21.1046 18.1046,22 17,22 L7,22 C5.89543,22 5,21.1046 5,20 L5,18.1407 C5,16.469 5.83551,14.9078 7.2265,13.9805 L10.1972,12 L7.2265,10.0195 C5.83551,9.09219 5,7.53103 5,5.85926 L5,4 Z"
        fill={color}
      />
    </Svg>
  );
}

export default BalanceIcon;
